import axios from 'axios'

export const v1_get_request_api = async (data: any) =>
  axios.get(`${process.env.REACT_APP_API_URL}/${data.queryKey[0]}?${data.queryKey[1] || ''}`) as any

export const v2_get_request_api = async (data: any) =>
  axios.get(
    `${process.env.REACT_APP_API_V2_URL}/${data.queryKey[0]}${
      data.queryKey[1] ? '?' + data.queryKey[1] : ''
    }`
  ) as any

export const v2_bulk_request_api = async (model: string, data: any) =>
  axios.post(`${process.env.REACT_APP_API_V2_URL}/${model}/bulk`, data) as any

export const urls = {
  news: 'news',
  summary: {
    invoice_by_ac_year: 'summary/invoice_by_ac_year',
    paid_invoice_by_ac_year: 'summary/paid_invoice_by_ac_year',
  },
}
